module.exports = __webpack_public_path__ + "static/20-16-fa3e0496da4c7ae3c84eb6d28ac7bc07.jpg";